import { useEffect, useState } from 'react';
import axios from 'axios';
import { Prod01 } from '../constants/ActionType';

let cached = null;
let inflight = null;

// GET /v1/organizations/mine once per login; label is "All organizations" for global users,
// the caller's org names joined with ", " otherwise, and "—" while loading / on failure.
export const fetchMyOrganizations = () => {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = axios
      .get(`${Prod01}/organizations/mine`)
      .then(({ data }) => {
        cached = data;
        return data;
      })
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

export const resetMyOrganizations = () => {
  cached = null;
};

export const organizationLabel = (scope) => {
  if (!scope) return '—';
  if (scope.global) return 'All organizations';
  const names = (scope.organizations || []).map((o) => o.name).filter(Boolean);
  return names.length ? names.join(', ') : '—';
};

export const useMyOrganizations = () => {
  const [scope, setScope] = useState(cached);
  useEffect(() => {
    let alive = true;
    fetchMyOrganizations().then((s) => {
      if (alive) setScope(s);
    });
    return () => {
      alive = false;
    };
  }, []);
  return { scope, label: organizationLabel(scope) };
};

export default useMyOrganizations;
